// @flow
import type {NodeChildren, DiagramPositioning} from '../types';

// If all nodes have x/y coordinates of 0, then it means we need to autoposition the nodes
// and set new x/y coordinates
export const getPositioning = (children: NodeChildren): DiagramPositioning => {
  const isAuto = children.reduce((prev, curr) => {
    if (!curr || typeof curr === 'string' || curr?.name === 'edge') {
      return prev && true;
    }
    return prev && curr.attributes.x === 0 && curr.attributes.y === 0;
  }, true);
  return isAuto ? 'auto' : 'manual';
};
